import React, {useEffect, useState} from "react";
import {TreeItem} from "@material-ui/lab";
import {AccountBalanceOutlined, AccountTreeOutlined, AlternateEmailRounded} from "@material-ui/icons";
import {Typography} from "@material-ui/core";
import axios from "axios";
import {COMPARE_BY_START, SHOW_AXIOS_ERROR} from "../core/FUNCS";
import dateHelper from "../core/dateHelper";

function MountSensor(props) {
    const {
        onMount,
    } = props;

    useEffect(() => {
        onMount(true);
        return () => onMount(false)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}

function  CampaignView(props){
    const {campaign, onCampaignSelected} = props;

    return <TreeItem nodeId={campaign.id} key={campaign.id}
                     onClick={() => onCampaignSelected(campaign)}
                     label={<div style={{ display: 'flex', margin: '5px' }}>
                         <AlternateEmailRounded/>
                         <div>
                             <Typography style={{ marginLeft: '5px' }} variant='body2'>
                                 {campaign.sendingProfile + ' (' +
                                 dateHelper.toShortDateRange(campaign.start, campaign.end) + ')'}
                             </Typography>
                         </div>
                     </div>}/>
}

function RseView(props){
    const {rse, onRseSelected, onCampaignSelected} = props;
    const [campaigns, setCampaigns] = useState([]);
    const loadMyChildren = () => {
        axios.get('api/phish/readCampaigns/'+ rse.id)
            .then(response => {
                setCampaigns(response.data);
            })
            .catch(SHOW_AXIOS_ERROR);
    };
    return <TreeItem nodeId={rse.id} key={rse.id}
                     onClick={() => onRseSelected(rse,loadMyChildren)}
                     label={<div style={{ display: 'flex', margin: '5px' }}>
        <AccountTreeOutlined/>
        <div>
            <Typography style={{ marginLeft: '5px' }} variant='body2' color='primary'>
                {rse.title} ({dateHelper.toShortDate(rse.start)})
            </Typography>
        </div>
    </div>}>
        <>
            <MountSensor onMount={isMount => {
                if(isMount){
                    loadMyChildren();
                }
            }}/>
            {
                (campaigns || []).map(camp => <CampaignView campaign={camp}
                                                            key={camp.id}
                                                            onCampaignSelected={onCampaignSelected}
                />)
            }
        </>

    </TreeItem>
}

export function ClientView(props){
    const {docxClient, onClientSelected, onRseSelected, onCampaignSelected} = props;
    const [rses, setRses] = useState([]);
    const loadMyChildren = () => {
        axios.get('api/phish/readRses/'+docxClient.id)
            .then(response => {
                setRses(response.data);
            })
            .catch(SHOW_AXIOS_ERROR);
    };

    return <TreeItem nodeId={docxClient.id} key={docxClient.id}

                     onClick={() => {onClientSelected(docxClient, loadMyChildren)}}
                     label={<div style={{ display: 'flex', margin: '5px' }}>
                         <AccountBalanceOutlined/>
                         <div>
                             <Typography style={{ marginLeft: '5px' }} variant='body2'>
                                 {docxClient.title}
                             </Typography>
                         </div>
                     </div>}>
        <>
            <MountSensor onMount={isMount => {
                if(isMount) {
                    loadMyChildren();
                }
            }}/>
            {
                (rses || [])
                    .sort(COMPARE_BY_START)
                    .map(rse => <RseView
                        key={rse.id}
                    onRseSelected={onRseSelected}
                    onCampaignSelected={onCampaignSelected}
                    rse={rse}/>)
            }
        </>
    </TreeItem>
}
